export const validateEmail = (email = '') => {
  const regEmail = /^[a-z0-9]+([._\-+]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+\.){1,63}[a-z0-9]+$/
  return regEmail.test(email.toLowerCase())
}

export const validateUrl = (url = '') => {
  const regUrl = /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/
  return regUrl.test(url.toLowerCase())
}

export const validatePwd = (pwd = '') => {
  const regPwd = /(?![0-9A-Z]+$)(?![0-9a-z]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,20}$/
  return regPwd.test(pwd)
}

// 校验验证码
export const validateCaptcha = (captcha = '') => captcha && captcha.length === 4
export const isNull = obj => Object.prototype.toString.call(obj) === '[object Null]'
export const isUndefinded = obj => Object.prototype.toString.call(obj) === '[object Undefined]'
